export enum StockStatus {
  AVAILABLE = "AVAILABLE",
  RENTED = "RENTED",
  ON_STREET = "ON_STREET",
  MAINTENANCE = "MAINTENANCE",
}

export enum StockCondition {
  NEW = "NEW",
  USED = "USED",
  WORN_OUT = "WORN_OUT",
}

export interface StockRequestDTO {
  productId: number;
  barcode: string;
  size: string;
  condition: StockCondition;
  photo?: string | null;
}

export interface StockItemDTO {
  id: number;
  barcode: string;
  size: string;
  condition: StockCondition;
  photoUrl: string | null;
  status?: StockStatus;
}

export interface StockResponseDTO {
  id: number;
  productId: number;
  productName: string;
  barcode: string;
  size: string;
  condition: StockCondition;
  photoUrl: string | null;
  createdAt: string;
  updatedAt: string;
  stockItems?: StockItemDTO[];
}

export interface StockAvailabilityResponseDTO {
  stockId: number;
  barcode: string;
  photoUrl: string | null;
  statusByDate: Record<string, StockStatus>;
}

export interface StockMaintenanceResponseDTO {
  idStockMaintenance: number;
  stockId: number;
  rentalId: number | null;
  startAt: string;
  expectedEndAt: string;
  endAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ExtendMaintenanceRequestDTO {
  newExpectedEndAt: string;
}

export interface StockSearchFilters {
  barcodes?: string[];
  statuses?: StockStatus[];
  conditions?: StockCondition[];
  sizes?: string[];
}

export interface StockSearchParams {
  size?: string[];
  condition?: StockCondition[];
  barcode?: string[];
  statuses?: StockStatus[];
  startDate?: string; // formato yyyy-MM-dd
  endDate?: string; // formato yyyy-MM-dd
  page?: number;
  pageSize?: number;
  sortBy?: keyof StockResponseDTO;
  sortDirection?: "ASC" | "DESC";
}
